import { InnerBlocks } from "@wordpress/block-editor";

export default function Save({ attributes }) {
  const { title, imageUrl, linkText, linkUrl, showLink } = attributes;
  
  return (
    <div className="tab-item" data-title={title}>
      {/* Store tab metadata */}
      <div 
        className="tab-metadata" 
        data-title={title}
        data-image-url={imageUrl || ''}
        data-link-text={linkText || ''}
        data-link-url={linkUrl || ''}
        data-show-link={showLink ? 'true' : 'false'}
        style={{ display: 'none' }}
      />
      
      {/* Tab content */}
      <div className="tab-inner-content">
        {imageUrl && (
          <div className="tab-image">
            <img src={imageUrl} alt={title} />
          </div>
        )}
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
